import styled from 'styled-components';

export const HeaderContainerStyle = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;

  h1,
  button {
    text-transform: uppercase;
    margin: 0;
  }
`;
